/* eslint-disable sonarjs/no-duplicate-string */
import { BenchmarkType } from '@/api/rest/resources/types/fact';
import { Logger } from '@/lib/logs/logger';

import { resolveThemeColor } from './resolveThemeColor';

export type BenchmarkStyle = {
  primary: string;
  text: string;
};

const exhaustivenessCheck = (benchmark: never): BenchmarkStyle => {
  Logger.error(`No color defined for linkage type "${benchmark}"`);
  return { primary: resolveThemeColor('transparent'), text: resolveThemeColor('transparent') };
};

export const getStyleForLinkage = (benchmark: BenchmarkType): BenchmarkStyle => {
  switch (benchmark) {
    case BenchmarkType.unchanged:
      return {
        primary: resolveThemeColor('benchmark-unchanged-background'),
        text: resolveThemeColor('text-secondary'),
      };
    case BenchmarkType.very_low:
      return { primary: resolveThemeColor('linkage-very-low-background'), text: resolveThemeColor('text-secondary') };
    case BenchmarkType.low:
      return { primary: resolveThemeColor('linkage-low-background'), text: resolveThemeColor('text-secondary') };
    case BenchmarkType.alerted:
      return { primary: resolveThemeColor('linkage-moderate-background'), text: resolveThemeColor('text-secondary') };
    case BenchmarkType.moderate:
      return { primary: resolveThemeColor('linkage-moderate-background'), text: resolveThemeColor('text-secondary') };
    case BenchmarkType.high:
      return { primary: resolveThemeColor('linkage-high-background'), text: resolveThemeColor('text-secondary') };
    case BenchmarkType.stable:
      return { primary: resolveThemeColor('linkage-high-background'), text: resolveThemeColor('text-secondary') };
    case BenchmarkType.very_high:
      return {
        primary: resolveThemeColor('linkage-very-high-background'),
        text: resolveThemeColor('text-secondary'),
      };
    default:
      return exhaustivenessCheck(benchmark);
  }
};
